const mainImg = document.querySelector(".custom_product_slider-new");
const myModalNew = document.getElementById("myModal");
const myModalWrap = document.getElementById("myModalWrapper");
const zoomingModal = document.getElementById("zoomModal");
const myModalClose = document.querySelector(".close");
const body = document.querySelector("body");

const customSlider = document.querySelector(".custom_product_slider");


window.addEventListener("DOMContentLoaded", (event) => {

  // Initialize the main slider
  $('.main-image').slick({
    arrows: false,
    asNavFor: '.thumbnail-slider',
  });

  // Initialize the thumbnail slider
  $('.thumbnail-slider').slick({
    slidesToShow: 5, // Adjust the number of thumbnails shown per row
    slidesToScroll: 1,
    focusOnSelect: true,
  });

  // Handle thumbnail click event
  $('.thumbnail-slider .thumbnail').on('click', function () {
    var index = $(this).data('slick-index');
    $('.main-image').slick('slickGoTo', index);
  });

  console.log($(window).width() )
  if ($(window).width() < 768){
 
    $('.custom_product_slider-new').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      infinite: true,
      arrows: false,
      
  });
  }

});

// $(".custom_product_slider-new").delegate(".all_slider_li", "click", function(){
//   // console.log($(this).data("media-position"), "new string");

//   $("#zoomModal").removeClass("notFadeModal");
//   document.querySelector("#zoomModal img").src = " ";
  
//   let currentMediaIndex = parseInt($(this).data("media-position") - 1);

// console.log(currentMediaIndex,'<!--- pijush---->')

//   myModalNew.style.visibility = "visible";
//   // myModalWrap.style.display = "block";
//   body.style.overflow = "hidden";
//   zoomingModal.style.opacity = "0";

//     $('.custom_product_slider').slick({
//       slidesToShow: 1,
//       slidesToScroll: 1,
//       dots: true,
//       infinite: false,
//       arrows: true,
//       initialSlide: currentMediaIndex,
//       vertical: false,
//       responsive: [               
//         {
//             breakpoint: 767,
//             settings: {
//             vertical: true,
//             arrows:false,
//             infinite: true
//             }
//         }]
//   });
//   // $(".prev-btn").click(function () {
//   //   $(".custom_product_slider").slick("slickPrev");
//   // });

//   // $(".next-btn").click(function () {
//   //     $(".custom_product_slider").slick("slickNext");
//   // });

//   // $(".prev-btn").addClass("slick-disabled");
//   // $(".custom_product_slider").on("afterChange", function () {
//   //     if ($(".slick-prev").hasClass("slick-disabled")) {
//   //         $(".prev-btn").addClass("slick-disabled");
//   //     } else {
//   //         $(".prev-btn").removeClass("slick-disabled");
//   //     }
//   //     if ($(".slick-next").hasClass("slick-disabled")) {
//   //         $(".next-btn").addClass("slick-disabled");
//   //     } else {
//   //         $(".next-btn").removeClass("slick-disabled");
//   //     }
//   // });

//   $(".custom_product_slider").delegate(".rrrrr", "click", function(e){
//     // console.log($(this), "new string");
//     // $(".custom-modal-image").removeClass("active-image");
//     // $(this).addClass("active-image");

//     let imgSrc = $(this).parent('.custom-modal-image').attr("data-image-src");

// //console.log(imgSrc,'<rrrrrrr>');
//     // var imgSrc = $(this).attr("image-src");
//     ///let imgSrc = e.target.dataset.imageSrc;

    
//     // console.log(imgSrc, "imgSrc");

//     $("#zoomModal").addClass("notFadeModal");
//     document.querySelector("#zoomModal img").src = imgSrc;

//     const container = document.querySelector(".zooming-modal-images-custom");
//     // const image = document.querySelector("#target-image");

//     // container.addEventListener("mousemove", e => {
//     //   const mouseY = e.clientY;
//     //   const containerHeight = container.offsetHeight;
//     //   const scrollHeight = container.scrollHeight;
//     //   const percentage = mouseY / containerHeight;
//     //   container.scrollTop = percentage * scrollHeight;
//     // });

//     // myModalWrap.style.display = "none";
//     // zoomingModal.style.display = "block";
//   });

//   $( "#zoomModal" ).click(function() {
//     $("#zoomModal").removeClass("notFadeModal");
//     document.querySelector("#zoomModal img").src = " ";
//   });

//   // $(document).ready(function(){
//   //   $('.feature-image')
//   //     .wrap('<span style="display:block;"></span>')
//   //     .css('display', 'block')
//   //     .parent()
//   //     .zoom();
//   // });

// });
// mainImg.addEventListener('click', (e) => { 
  
//   myModalNew.style.visibility = "visible";
//   body.style.overflow = "hidden";

//   // $(window).trigger('resize');

//   $(document).ready(function(){
    
//   });
//   // customSlider.style.visibility = "visible";
//   // $('.your_hidden_slider_class_or_id').slick("refresh");
// })


myModalClose.addEventListener('click', () => {
  // $('.custom_product_slider').slick("unslick");
  zoomingModal.style.opacity = "0";
  myModal.style.visibility = "hidden";
  body.style.overflow = "auto";
  callMyFunc();

})


// window.onclick = function(event) {
//   // $('.custom_product_slider').slick("unslick");
//   zoomingModal.style.opacity = "0";
//   if (event.target == myModal) {
//     myModalNew.style.visibility = "hidden";
//     callMyFunc();
//   }
// }

function callMyFunc(){
  setTimeout(()=>{
    $('.custom_product_slider').slick("unslick");
  },1500)
};



// $(document).ready(function() {
//   // set up click event listener on each image
//   $('img[data-src]').click(function() {
//     var src = $(this).data('src');

//     // update the target image with the selected image
//     $('#target-image').attr('src', src);
//   });
// });